import { Link } from 'react-router';

export function EmptyInventory() {
  return (
    <div className="text-center py-16">
      <span className="text-6xl">✨</span>
      <h2 className="mt-4 text-2xl font-bold text-[var(--color-brand-text)]">
        Coming Soon
      </h2>
      <p className="mt-2 text-[var(--color-brand-muted)] max-w-md mx-auto">
        New handmade GlamFlops are being crafted. Request a custom pair or check back soon!
      </p>
      <Link
        to="/preorder"
        className="mt-6 inline-block bg-[var(--color-brand-accent)] text-white px-6 py-3 rounded-full font-medium hover:opacity-90 transition-opacity"
      >
        Request Custom Pair
      </Link>
    </div>
  );
}

export function SoldInspirationBanner() {
  return (
    <div className="bg-[var(--color-glam-cream)] border border-[var(--color-glam-gold-light)] rounded-lg p-4 text-center text-sm">
      <p className="text-[var(--color-brand-muted)]">
        💎 Sold and reserved items are shown for inspiration.{' '}
        <Link to="/preorder" className="text-[var(--color-brand-accent)] font-medium hover:underline">
          Request a similar pair
        </Link>
      </p>
    </div>
  );
}
